module.exports = __webpack_public_path__ + "static/media/icon_new.73ca015f.png";